import React from "react";
import {
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
  MDBIcon
} from "mdbreact";
import CardNotifications from "./../Cards/CardNotification";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../helpers/axios";
import { ENDPOINT_DELETE_NOTIFICATIONS } from "../../helpers/endpoints";
export default function Notification({ notifications, update }) {
  const dispatch = useDispatch();

  const changePost = async (postId, creator, urlImg, title) => {
    dispatch({
      type: "CHANGE_POST",
      payload: {
        postId,
        creator,
        urlImg,
        title
      }
    });
    dispatch({
      type: "CLOSE_SIDEBAR"
    });
    const { data } = await axios.delete(
      ENDPOINT_DELETE_NOTIFICATIONS({ user: creator, post: postId })
    );
    if (data) update();
  };
  const Notifications = ({ notifications }) =>
    notifications.map(notification => (
      <MDBDropdownItem key={notification._id}>
        <CardNotifications
          options={options}
          {...notification}
          changePost={changePost}
        />
      </MDBDropdownItem>
    ));

  const options = {
    timeZone: "UTC",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric"
  };

  return (
    <MDBDropdown>
      <MDBDropdownToggle className="btn-send">
        <div className="notifications"> {notifications.length} </div>
        <MDBIcon icon="bell" />
      </MDBDropdownToggle>
      <MDBDropdownMenu basic className="scroll">
        <Notifications notifications={notifications} />
      </MDBDropdownMenu>
    </MDBDropdown>
  );
}
